import axios from 'axios';

export default function setup() {
  axios.interceptors.request.use(function(config) {


    // Comment Code from line 8 - 14 on Live till KAVACH backend deployment pending
    const userAccessToken = window.localStorage.getItem('access_token')
    const token = userAccessToken? userAccessToken.replace(/"/g, '') : false;

    if(token) {

      (config.headers.Authorization) ? config.headers.Authorization = `Bearer ${token}` : config.headers.authorization = `Bearer ${token}`;
    }
    
    config.headers['Strict-Transport-Security'] = `max-age=31536000; includeSubDomains; preload`;
    config.headers['X-Content-Type-Options'] = 'nosniff';
    config.headers['X-Frame-Options'] = 'sameorigin';
    config.headers['Content-Security-Policy'] = `default-src 'self'`;

    return config;

  }, function(err) {

    console.log('interceptors err==', err);
    return Promise.reject(err);
  });
};



// WEBPACK FOOTER //
// ./src/helpers/interceptors.js